import { UAParser } from "ua-parser-js";

export const getDeviceId = () => {
  let deviceId = localStorage.getItem("device_id");

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("device_id", deviceId);
  }

  return deviceId;
};


export const getDeviceName = () => {
  const parser = new UAParser();
  const result = parser.getResult();

  const os = result.os?.name || "Unknown OS";
  const osVersion = result.os?.version || "";

  const browser = result.browser?.name || "Unknown Browser";
  const browserVersion = result.browser?.version || "";

  const deviceType = result.device?.type || "desktop";

  return `${os} ${osVersion} - ${browser} ${browserVersion} (${deviceType})`.trim();
};